import React from 'react';

const Navigation = ({ activeTab, setActiveTab }) => {
  const tabs = [
    { id: 'home', label: 'Inicio', icon: '🏠' },
    // { id: 'chatbot', label: 'Asistente IA', icon: '🤖' },
    { id: 'buying', label: 'Comprar', icon: '🔍' },
    { id: 'selling', label: 'Vender', icon: '💰' },
    { id: 'about', label: 'Nosotros', icon: '👥' },
    { id: 'mission', label: 'Nuestra Misión', icon: '🎯' },
    { id: 'contact', label: 'Contacto', icon: '📞' },
    {
      id: 'prestamos',
      label: 'Préstamos Puente',
      icon: '📄💰',
      external: true,
      url: 'https://linkcapitalsolutions.com'
    }
  ];


  return (
    <nav className="navigation-container">
      <div className="nav-brand">
        <h2>Link Real Estate</h2>
        <p className="nav-tagline">El futuro de los bienes raíces</p>
      </div>
      
      <div className="nav-tabs">
        {tabs.map(tab =>
          tab.external ? (
            <a
              key={tab.id}
              href={tab.url}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-tab"
              style={{ textDecoration: 'none', color: 'inherit' }}
            >
              <span className="nav-icon">{tab.icon}</span>
              <span className="nav-label">{tab.label}</span>
            </a>
          ) : (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`nav-tab ${activeTab === tab.id ? 'active' : ''}`}
            >
              <span className="nav-icon">{tab.icon}</span>
              <span className="nav-label">{tab.label}</span>
            </button>
          )
        )}
      </div>

    </nav>
  );
};

export default Navigation;
